(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cs27-chapter"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cs27-carousel')) {
  customElements.define('cs27-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.slides = [...this.querySelectorAll('.cs27-carousel-slide')];
      this.track = this.querySelector('.cs27-carousel-track');
      this.position = this.querySelector('.cs27-carousel-position');
      this.playback = this.querySelector('[data-playback]');
      this.index = 0;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.visible = false;
      this.hovered = false;
      this.focused = false;
      this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => {
        this.paused = true;
        this.show(this.index + Number(button.dataset.direction));
        this.sync();
      }));
      this.playback.addEventListener('click', () => { this.paused = !this.paused; this.sync(); });
      this.addEventListener('mouseenter', () => { this.hovered = true; this.sync(); });
      this.addEventListener('mouseleave', () => { this.hovered = false; this.sync(); });
      this.addEventListener('focusin', () => { this.focused = true; this.sync(); });
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.sync(); } });
      this.addEventListener('pointerdown', event => { this.startX = event.clientX; });
      this.addEventListener('pointerup', event => {
        if (event.target.closest('button') || this.startX === undefined) return;
        const distance = event.clientX - this.startX;
        this.startX = undefined;
        if (Math.abs(distance) > 45) { this.paused = true; this.show(this.index + (distance < 0 ? 1 : -1)); this.sync(); }
      });
      this.motionChange = () => { if (this.motion.matches) this.paused = true; this.sync(); };
      this.motion.addEventListener('change', this.motionChange);
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); }, { threshold: 0.2 });
      this.observer.observe(this);
      this.show(0);
      this.sync();
    }
    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.track.style.transform = `translateX(-${this.index * 100}%)`;
      this.slides.forEach((slide, i) => slide.setAttribute('aria-hidden', String(i !== this.index)));
      this.position.textContent = `${this.index + 1} / ${this.slides.length}`;
    }
    sync() {
      clearInterval(this.timer);
      this.playback.textContent = this.paused ? '▶' : 'Ⅱ';
      this.playback.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      if (!this.paused && this.visible && !this.hovered && !this.focused && this.slides.length > 1) this.timer = setInterval(() => this.show(this.index + 1), 5000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.observer?.disconnect();
      this.motion?.removeEventListener('change', this.motionChange);
      this.initialized = false;
    }
  });
}

if (!customElements.get('cs27-finale')) {
  customElements.define('cs27-finale', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.revealed || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.dataset.revealed = 'true';
        this.classList.add('is-revealed');
        this.observer.disconnect();
      }, { threshold: .18 });
      this.observer.observe(this);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs27-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cs27-metrics')) {
  customElements.define('cs27-metrics', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.revealed === 'true' || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.classList.add('is-armed');
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.dataset.revealed = 'true';
        this.classList.add('is-revealed');
        this.observer.disconnect();
      }, { threshold: 0.2 });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      this.classList.remove('is-armed');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs27-sc-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cs27-metrics')) {
  customElements.define('cs27-metrics', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.revealed === 'true' || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.classList.add('is-armed');
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.dataset.revealed = 'true';
        this.classList.add('is-revealed');
        this.observer.disconnect();
      }, { threshold: 0.2 });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      this.classList.remove('is-armed');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["csad27-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cs27-metrics')) {
  customElements.define('cs27-metrics', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.revealed === 'true' || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.classList.add('is-armed');
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.dataset.revealed = 'true';
        this.classList.add('is-revealed');
        this.observer.disconnect();
      }, { threshold: 0.2 });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      this.classList.remove('is-armed');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["csag27-chapter"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cs27-carousel')) {
  customElements.define('cs27-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.slides = [...this.querySelectorAll('.cs27-carousel-slide')];
      this.track = this.querySelector('.cs27-carousel-track');
      this.position = this.querySelector('.cs27-carousel-position');
      this.playback = this.querySelector('[data-playback]');
      this.index = 0;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.visible = false;
      this.hovered = false;
      this.focused = false;
      this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => {
        this.paused = true;
        this.show(this.index + Number(button.dataset.direction));
        this.sync();
      }));
      this.playback.addEventListener('click', () => { this.paused = !this.paused; this.sync(); });
      this.addEventListener('mouseenter', () => { this.hovered = true; this.sync(); });
      this.addEventListener('mouseleave', () => { this.hovered = false; this.sync(); });
      this.addEventListener('focusin', () => { this.focused = true; this.sync(); });
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.sync(); } });
      this.addEventListener('pointerdown', event => { this.startX = event.clientX; });
      this.addEventListener('pointerup', event => {
        if (event.target.closest('button') || this.startX === undefined) return;
        const distance = event.clientX - this.startX;
        this.startX = undefined;
        if (Math.abs(distance) > 45) { this.paused = true; this.show(this.index + (distance < 0 ? 1 : -1)); this.sync(); }
      });
      this.motionChange = () => { if (this.motion.matches) this.paused = true; this.sync(); };
      this.motion.addEventListener('change', this.motionChange);
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); }, { threshold: 0.2 });
      this.observer.observe(this);
      this.show(0);
      this.sync();
    }
    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.track.style.transform = `translateX(-${this.index * 100}%)`;
      this.slides.forEach((slide, i) => slide.setAttribute('aria-hidden', String(i !== this.index)));
      this.position.textContent = `${this.index + 1} / ${this.slides.length}`;
    }
    sync() {
      clearInterval(this.timer);
      this.playback.textContent = this.paused ? '▶' : 'Ⅱ';
      this.playback.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      if (!this.paused && this.visible && !this.hovered && !this.focused && this.slides.length > 1) this.timer = setInterval(() => this.show(this.index + 1), 5000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.observer?.disconnect();
      this.motion?.removeEventListener('change', this.motionChange);
      this.initialized = false;
    }
  });
}

if (!customElements.get('cs27-finale')) {
  customElements.define('cs27-finale', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.revealed || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.dataset.revealed = 'true';
        this.classList.add('is-revealed');
        this.observer.disconnect();
      }, { threshold: .18 });
      this.observer.observe(this);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["csag27-hero"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('cs27-metrics')) {
  customElements.define('cs27-metrics', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.revealed === 'true' || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.classList.add('is-armed');
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.dataset.revealed = 'true';
        this.classList.add('is-revealed');
        this.observer.disconnect();
      }, { threshold: 0.2 });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      this.classList.remove('is-armed');
    }
  });
}


if (!customElements.get('csag27-motion')) {
  customElements.define('csag27-motion', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      if (!this.video || !this.button) return;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.manualPause = this.reduced.matches;
      this.video.muted = true;
      this.video.autoplay = !this.manualPause;
      this.update = () => { this.button.textContent = this.video.paused ? 'Play' : 'Pause'; this.button.setAttribute('aria-label', this.video.paused ? 'Play banner video' : 'Pause banner video'); };
      this.toggle = () => { this.manualPause = !this.video.paused; if (this.manualPause) this.video.pause(); else this.video.play().catch(this.update); };
      this.motionChange = () => { this.manualPause = this.reduced.matches; if (this.manualPause) this.video.pause(); else this.video.play().catch(this.update); };
      this.button.addEventListener('click', this.toggle);
      this.video.addEventListener('play', this.update);
      this.video.addEventListener('pause', this.update);
      this.reduced.addEventListener('change', this.motionChange);
      if (this.manualPause) this.video.pause();
      this.observer = new IntersectionObserver(entries => { const visible = entries[0].isIntersecting; if (!visible || this.manualPause) this.video.pause(); else this.video.play().catch(this.update); }, { threshold: 0.15 });
      this.observer.observe(this);
      this.update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.button?.removeEventListener('click', this.toggle);
      this.video?.removeEventListener('play', this.update);
      this.video?.removeEventListener('pause', this.update);
      this.reduced?.removeEventListener('change', this.motionChange);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["csbk27-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cs27-metrics')) {
  customElements.define('cs27-metrics', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.revealed === 'true' || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.classList.add('is-armed');
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.dataset.revealed = 'true';
        this.classList.add('is-revealed');
        this.observer.disconnect();
      }, { threshold: 0.2 });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      this.classList.remove('is-armed');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["csbk27-work"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cs27-carousel')) {
  customElements.define('cs27-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.slides = [...this.querySelectorAll('.cs27-carousel-slide')];
      this.track = this.querySelector('.cs27-carousel-track');
      this.position = this.querySelector('.cs27-carousel-position');
      this.playback = this.querySelector('[data-playback]');
      this.index = 0;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.visible = false;
      this.hovered = false;
      this.focused = false;
      this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => {
        this.paused = true;
        this.show(this.index + Number(button.dataset.direction));
        this.sync();
      }));
      this.playback.addEventListener('click', () => { this.paused = !this.paused; this.sync(); });
      this.addEventListener('mouseenter', () => { this.hovered = true; this.sync(); });
      this.addEventListener('mouseleave', () => { this.hovered = false; this.sync(); });
      this.addEventListener('focusin', () => { this.focused = true; this.sync(); });
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.sync(); } });
      this.addEventListener('pointerdown', event => { this.startX = event.clientX; });
      this.addEventListener('pointerup', event => {
        if (event.target.closest('button') || this.startX === undefined) return;
        const distance = event.clientX - this.startX;
        this.startX = undefined;
        if (Math.abs(distance) > 45) { this.paused = true; this.show(this.index + (distance < 0 ? 1 : -1)); this.sync(); }
      });
      this.motionChange = () => { if (this.motion.matches) this.paused = true; this.sync(); };
      this.motion.addEventListener('change', this.motionChange);
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); }, { threshold: 0.2 });
      this.observer.observe(this);
      this.show(0);
      this.sync();
    }
    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.track.style.transform = `translateX(-${this.index * 100}%)`;
      this.slides.forEach((slide, i) => slide.setAttribute('aria-hidden', String(i !== this.index)));
      this.position.textContent = `${this.index + 1} / ${this.slides.length}`;
    }
    sync() {
      clearInterval(this.timer);
      this.playback.textContent = this.paused ? '▶' : 'Ⅱ';
      this.playback.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      if (!this.paused && this.visible && !this.hovered && !this.focused && this.slides.length > 1) this.timer = setInterval(() => this.show(this.index + 1), 5000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.observer?.disconnect();
      this.motion?.removeEventListener('change', this.motionChange);
      this.initialized = false;
    }
  });
}

if (!customElements.get('cs27-finale')) {
  customElements.define('cs27-finale', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.revealed || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.dataset.revealed = 'true';
        this.classList.add('is-revealed');
        this.observer.disconnect();
      }, { threshold: .18 });
      this.observer.observe(this);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["csbz-chapter"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('csbz-carousel')) {
  customElements.define('csbz-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.slides = [...this.querySelectorAll('.csbz-carousel-slide')];
      this.track = this.querySelector('.csbz-carousel-track');
      this.position = this.querySelector('.csbz-carousel-position');
      this.playback = this.querySelector('[data-playback]');
      this.index = 0;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.visible = false;
      this.hovered = false;
      this.focused = false;
      this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => {
        this.paused = true;
        this.show(this.index + Number(button.dataset.direction));
        this.sync();
      }));
      this.playback.addEventListener('click', () => { this.paused = !this.paused; this.sync(); });
      this.addEventListener('mouseenter', () => { this.hovered = true; this.sync(); });
      this.addEventListener('mouseleave', () => { this.hovered = false; this.sync(); });
      this.addEventListener('focusin', () => { this.focused = true; this.sync(); });
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.sync(); } });
      this.addEventListener('pointerdown', event => { this.startX = event.clientX; });
      this.addEventListener('pointerup', event => {
        if (event.target.closest('button') || this.startX === undefined) return;
        const distance = event.clientX - this.startX;
        this.startX = undefined;
        if (Math.abs(distance) > 45) { this.paused = true; this.show(this.index + (distance < 0 ? 1 : -1)); this.sync(); }
      });
      this.motionChange = () => { if (this.motion.matches) this.paused = true; this.sync(); };
      this.motion.addEventListener('change', this.motionChange);
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); }, { threshold: 0.2 });
      this.observer.observe(this);
      this.show(0);
      this.sync();
    }
    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.track.style.transform = `translateX(-${this.index * 100}%)`;
      this.slides.forEach((slide, i) => slide.setAttribute('aria-hidden', String(i !== this.index)));
      this.position.textContent = `${this.index + 1} / ${this.slides.length}`;
    }
    sync() {
      clearInterval(this.timer);
      this.playback.textContent = this.paused ? '▶' : 'Ⅱ';
      this.playback.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      if (!this.paused && this.visible && !this.hovered && !this.focused && this.slides.length > 1) this.timer = setInterval(() => this.show(this.index + 1), 5000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.observer?.disconnect();
      this.motion?.removeEventListener('change', this.motionChange);
      this.initialized = false;
    }
  });
}

if (!customElements.get('csbz-finale')) {
  customElements.define('csbz-finale', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.revealed || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.dataset.revealed = 'true';
        this.classList.add('is-revealed');
        this.observer.disconnect();
      }, { threshold: .18 });
      this.observer.observe(this);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["csbz-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('csbz-metrics')) {
  customElements.define('csbz-metrics', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.revealed === 'true' || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.classList.add('is-armed');
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.dataset.revealed = 'true';
        this.classList.add('is-revealed');
        this.observer.disconnect();
      }, { threshold: 0.2 });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      this.classList.remove('is-armed');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["csdp27-chapter"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cs27-carousel')) {
  customElements.define('cs27-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.slides = [...this.querySelectorAll('.cs27-carousel-slide')];
      this.track = this.querySelector('.cs27-carousel-track');
      this.position = this.querySelector('.cs27-carousel-position');
      this.playback = this.querySelector('[data-playback]');
      this.index = 0;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.visible = false;
      this.hovered = false;
      this.focused = false;
      this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => {
        this.paused = true;
        this.show(this.index + Number(button.dataset.direction));
        this.sync();
      }));
      this.playback.addEventListener('click', () => { this.paused = !this.paused; this.sync(); });
      this.addEventListener('mouseenter', () => { this.hovered = true; this.sync(); });
      this.addEventListener('mouseleave', () => { this.hovered = false; this.sync(); });
      this.addEventListener('focusin', () => { this.focused = true; this.sync(); });
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.sync(); } });
      this.addEventListener('pointerdown', event => { this.startX = event.clientX; });
      this.addEventListener('pointerup', event => {
        if (event.target.closest('button') || this.startX === undefined) return;
        const distance = event.clientX - this.startX;
        this.startX = undefined;
        if (Math.abs(distance) > 45) { this.paused = true; this.show(this.index + (distance < 0 ? 1 : -1)); this.sync(); }
      });
      this.motionChange = () => { if (this.motion.matches) this.paused = true; this.sync(); };
      this.motion.addEventListener('change', this.motionChange);
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); }, { threshold: 0.2 });
      this.observer.observe(this);
      this.show(0);
      this.sync();
    }
    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.track.style.transform = `translateX(-${this.index * 100}%)`;
      this.slides.forEach((slide, i) => slide.setAttribute('aria-hidden', String(i !== this.index)));
      this.position.textContent = `${this.index + 1} / ${this.slides.length}`;
    }
    sync() {
      clearInterval(this.timer);
      this.playback.textContent = this.paused ? '▶' : 'Ⅱ';
      this.playback.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      if (!this.paused && this.visible && !this.hovered && !this.focused && this.slides.length > 1) this.timer = setInterval(() => this.show(this.index + 1), 5000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.observer?.disconnect();
      this.motion?.removeEventListener('change', this.motionChange);
      this.initialized = false;
    }
  });
}

if (!customElements.get('cs27-finale')) {
  customElements.define('cs27-finale', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.revealed || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.dataset.revealed = 'true';
        this.classList.add('is-revealed');
        this.observer.disconnect();
      }, { threshold: .18 });
      this.observer.observe(this);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["csdp27-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cs27-metrics')) {
  customElements.define('cs27-metrics', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.revealed === 'true' || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.classList.add('is-armed');
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.dataset.revealed = 'true';
        this.classList.add('is-revealed');
        this.observer.disconnect();
      }, { threshold: 0.2 });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      this.classList.remove('is-armed');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["csf2-chapter"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cs27-carousel')) {
  customElements.define('cs27-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.slides = [...this.querySelectorAll('.cs27-carousel-slide')];
      this.track = this.querySelector('.cs27-carousel-track');
      this.position = this.querySelector('.cs27-carousel-position');
      this.playback = this.querySelector('[data-playback]');
      this.index = 0;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.visible = false;
      this.hovered = false;
      this.focused = false;
      this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => {
        this.paused = true;
        this.show(this.index + Number(button.dataset.direction));
        this.sync();
      }));
      this.playback.addEventListener('click', () => { this.paused = !this.paused; this.sync(); });
      this.addEventListener('mouseenter', () => { this.hovered = true; this.sync(); });
      this.addEventListener('mouseleave', () => { this.hovered = false; this.sync(); });
      this.addEventListener('focusin', () => { this.focused = true; this.sync(); });
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.sync(); } });
      this.addEventListener('pointerdown', event => { this.startX = event.clientX; });
      this.addEventListener('pointerup', event => {
        if (event.target.closest('button') || this.startX === undefined) return;
        const distance = event.clientX - this.startX;
        this.startX = undefined;
        if (Math.abs(distance) > 45) { this.paused = true; this.show(this.index + (distance < 0 ? 1 : -1)); this.sync(); }
      });
      this.motionChange = () => { if (this.motion.matches) this.paused = true; this.sync(); };
      this.motion.addEventListener('change', this.motionChange);
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); }, { threshold: 0.2 });
      this.observer.observe(this);
      this.show(0);
      this.sync();
    }
    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.track.style.transform = `translateX(-${this.index * 100}%)`;
      this.slides.forEach((slide, i) => slide.setAttribute('aria-hidden', String(i !== this.index)));
      this.position.textContent = `${this.index + 1} / ${this.slides.length}`;
    }
    sync() {
      clearInterval(this.timer);
      this.playback.textContent = this.paused ? '▶' : 'Ⅱ';
      this.playback.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      if (!this.paused && this.visible && !this.hovered && !this.focused && this.slides.length > 1) this.timer = setInterval(() => this.show(this.index + 1), 5000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.observer?.disconnect();
      this.motion?.removeEventListener('change', this.motionChange);
      this.initialized = false;
    }
  });
}

if (!customElements.get('cs27-finale')) {
  customElements.define('cs27-finale', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.revealed || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.dataset.revealed = 'true';
        this.classList.add('is-revealed');
        this.observer.disconnect();
      }, { threshold: .18 });
      this.observer.observe(this);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["csf2-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cs27-metrics')) {
  customElements.define('cs27-metrics', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.revealed === 'true' || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.classList.add('is-armed');
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.dataset.revealed = 'true';
        this.classList.add('is-revealed');
        this.observer.disconnect();
      }, { threshold: 0.2 });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      this.classList.remove('is-armed');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["csfol27-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cs27-metrics')) {
  customElements.define('cs27-metrics', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.revealed === 'true' || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.classList.add('is-armed');
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.dataset.revealed = 'true';
        this.classList.add('is-revealed');
        this.observer.disconnect();
      }, { threshold: 0.2 });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      this.classList.remove('is-armed');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["csgb-chapter"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('csgb-carousel')) {
  customElements.define('csgb-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.slides = [...this.querySelectorAll('.csgb-carousel-slide')];
      this.track = this.querySelector('.csgb-carousel-track');
      this.position = this.querySelector('.csgb-carousel-position');
      this.playback = this.querySelector('[data-playback]');
      this.index = 0;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.visible = false;
      this.hovered = false;
      this.focused = false;
      this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => {
        this.paused = true;
        this.show(this.index + Number(button.dataset.direction));
        this.sync();
      }));
      this.playback.addEventListener('click', () => { this.paused = !this.paused; this.sync(); });
      this.addEventListener('mouseenter', () => { this.hovered = true; this.sync(); });
      this.addEventListener('mouseleave', () => { this.hovered = false; this.sync(); });
      this.addEventListener('focusin', () => { this.focused = true; this.sync(); });
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.sync(); } });
      this.addEventListener('pointerdown', event => { this.startX = event.clientX; });
      this.addEventListener('pointerup', event => {
        if (event.target.closest('button') || this.startX === undefined) return;
        const distance = event.clientX - this.startX;
        this.startX = undefined;
        if (Math.abs(distance) > 45) { this.paused = true; this.show(this.index + (distance < 0 ? 1 : -1)); this.sync(); }
      });
      this.motionChange = () => { if (this.motion.matches) this.paused = true; this.sync(); };
      this.motion.addEventListener('change', this.motionChange);
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); }, { threshold: 0.2 });
      this.observer.observe(this);
      this.show(0);
      this.sync();
    }
    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.track.style.transform = `translateX(-${this.index * 100}%)`;
      this.slides.forEach((slide, i) => slide.setAttribute('aria-hidden', String(i !== this.index)));
      this.position.textContent = `${this.index + 1} / ${this.slides.length}`;
    }
    sync() {
      clearInterval(this.timer);
      this.playback.textContent = this.paused ? '▶' : 'Ⅱ';
      this.playback.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      if (!this.paused && this.visible && !this.hovered && !this.focused && this.slides.length > 1) this.timer = setInterval(() => this.show(this.index + 1), 5000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.observer?.disconnect();
      this.motion?.removeEventListener('change', this.motionChange);
      this.initialized = false;
    }
  });
}

if (!customElements.get('csgb-finale')) {
  customElements.define('csgb-finale', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.revealed || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.dataset.revealed = 'true';
        this.classList.add('is-revealed');
        this.observer.disconnect();
      }, { threshold: .18 });
      this.observer.observe(this);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["csgb-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('csgb-metrics')) {
  customElements.define('csgb-metrics', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.revealed === 'true' || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.classList.add('is-armed');
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.dataset.revealed = 'true';
        this.classList.add('is-revealed');
        this.observer.disconnect();
      }, { threshold: 0.2 });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      this.classList.remove('is-armed');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["csm27-chapter"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cs27-carousel')) {
  customElements.define('cs27-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.slides = [...this.querySelectorAll('.cs27-carousel-slide')];
      this.track = this.querySelector('.cs27-carousel-track');
      this.position = this.querySelector('.cs27-carousel-position');
      this.playback = this.querySelector('[data-playback]');
      this.index = 0;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.visible = false;
      this.hovered = false;
      this.focused = false;
      this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => {
        this.paused = true;
        this.show(this.index + Number(button.dataset.direction));
        this.sync();
      }));
      this.playback.addEventListener('click', () => { this.paused = !this.paused; this.sync(); });
      this.addEventListener('mouseenter', () => { this.hovered = true; this.sync(); });
      this.addEventListener('mouseleave', () => { this.hovered = false; this.sync(); });
      this.addEventListener('focusin', () => { this.focused = true; this.sync(); });
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.sync(); } });
      this.addEventListener('pointerdown', event => { this.startX = event.clientX; });
      this.addEventListener('pointerup', event => {
        if (event.target.closest('button') || this.startX === undefined) return;
        const distance = event.clientX - this.startX;
        this.startX = undefined;
        if (Math.abs(distance) > 45) { this.paused = true; this.show(this.index + (distance < 0 ? 1 : -1)); this.sync(); }
      });
      this.motionChange = () => { if (this.motion.matches) this.paused = true; this.sync(); };
      this.motion.addEventListener('change', this.motionChange);
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); }, { threshold: 0.2 });
      this.observer.observe(this);
      this.show(0);
      this.sync();
    }
    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.track.style.transform = `translateX(-${this.index * 100}%)`;
      this.slides.forEach((slide, i) => slide.setAttribute('aria-hidden', String(i !== this.index)));
      this.position.textContent = `${this.index + 1} / ${this.slides.length}`;
    }
    sync() {
      clearInterval(this.timer);
      this.playback.textContent = this.paused ? '▶' : 'Ⅱ';
      this.playback.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      if (!this.paused && this.visible && !this.hovered && !this.focused && this.slides.length > 1) this.timer = setInterval(() => this.show(this.index + 1), 5000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.observer?.disconnect();
      this.motion?.removeEventListener('change', this.motionChange);
      this.initialized = false;
    }
  });
}

if (!customElements.get('cs27-finale')) {
  customElements.define('cs27-finale', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.revealed || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.dataset.revealed = 'true';
        this.classList.add('is-revealed');
        this.observer.disconnect();
      }, { threshold: .18 });
      this.observer.observe(this);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["csm27-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cs27-metrics')) {
  customElements.define('cs27-metrics', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.revealed === 'true' || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.classList.add('is-armed');
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.dataset.revealed = 'true';
        this.classList.add('is-revealed');
        this.observer.disconnect();
      }, { threshold: 0.2 });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      this.classList.remove('is-armed');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cssr27-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cs27-metrics')) {
  customElements.define('cs27-metrics', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.revealed === 'true' || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.classList.add('is-armed');
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.dataset.revealed = 'true';
        this.classList.add('is-revealed');
        this.observer.disconnect();
      }, { threshold: 0.2 });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      this.classList.remove('is-armed');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["csst27-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cs27-metrics')) {
  customElements.define('cs27-metrics', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.revealed === 'true' || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.classList.add('is-armed');
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.dataset.revealed = 'true';
        this.classList.add('is-revealed');
        this.observer.disconnect();
      }, { threshold: 0.2 });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      this.classList.remove('is-armed');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cssu27-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cs27-metrics')) {
  customElements.define('cs27-metrics', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.revealed === 'true' || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.classList.add('is-armed');
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.dataset.revealed = 'true';
        this.classList.add('is-revealed');
        this.observer.disconnect();
      }, { threshold: 0.2 });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      this.classList.remove('is-armed');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cssu27-work"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cs27-carousel')) {
  customElements.define('cs27-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.slides = [...this.querySelectorAll('.cs27-carousel-slide')];
      this.track = this.querySelector('.cs27-carousel-track');
      this.position = this.querySelector('.cs27-carousel-position');
      this.playback = this.querySelector('[data-playback]');
      this.index = 0;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.visible = false;
      this.hovered = false;
      this.focused = false;
      this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => {
        this.paused = true;
        this.show(this.index + Number(button.dataset.direction));
        this.sync();
      }));
      this.playback.addEventListener('click', () => { this.paused = !this.paused; this.sync(); });
      this.addEventListener('mouseenter', () => { this.hovered = true; this.sync(); });
      this.addEventListener('mouseleave', () => { this.hovered = false; this.sync(); });
      this.addEventListener('focusin', () => { this.focused = true; this.sync(); });
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.sync(); } });
      this.addEventListener('pointerdown', event => { this.startX = event.clientX; });
      this.addEventListener('pointerup', event => {
        if (event.target.closest('button') || this.startX === undefined) return;
        const distance = event.clientX - this.startX;
        this.startX = undefined;
        if (Math.abs(distance) > 45) { this.paused = true; this.show(this.index + (distance < 0 ? 1 : -1)); this.sync(); }
      });
      this.motionChange = () => { if (this.motion.matches) this.paused = true; this.sync(); };
      this.motion.addEventListener('change', this.motionChange);
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); }, { threshold: 0.2 });
      this.observer.observe(this);
      this.show(0);
      this.sync();
    }
    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.track.style.transform = `translateX(-${this.index * 100}%)`;
      this.slides.forEach((slide, i) => slide.setAttribute('aria-hidden', String(i !== this.index)));
      this.position.textContent = `${this.index + 1} / ${this.slides.length}`;
    }
    sync() {
      clearInterval(this.timer);
      this.playback.textContent = this.paused ? '▶' : 'Ⅱ';
      this.playback.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      if (!this.paused && this.visible && !this.hovered && !this.focused && this.slides.length > 1) this.timer = setInterval(() => this.show(this.index + 1), 5000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.observer?.disconnect();
      this.motion?.removeEventListener('change', this.motionChange);
      this.initialized = false;
    }
  });
}

if (!customElements.get('cs27-finale')) {
  customElements.define('cs27-finale', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.revealed || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.dataset.revealed = 'true';
        this.classList.add('is-revealed');
        this.observer.disconnect();
      }, { threshold: .18 });
      this.observer.observe(this);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cstt27-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cs27-metrics')) {
  customElements.define('cs27-metrics', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.revealed === 'true' || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.classList.add('is-armed');
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.dataset.revealed = 'true';
        this.classList.add('is-revealed');
        this.observer.disconnect();
      }, { threshold: 0.2 });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      this.classList.remove('is-armed');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["csvs27-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cs27-metrics')) {
  customElements.define('cs27-metrics', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.revealed === 'true' || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.classList.add('is-armed');
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.dataset.revealed = 'true';
        this.classList.add('is-revealed');
        this.observer.disconnect();
      }, { threshold: 0.2 });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      this.classList.remove('is-armed');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
